<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="intro-content box text-center">
            <h2>Thank you!</h2>
            <p>Your payment has been received and your property will be listed</p>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      :autoHeight="true"
      id="intro-carousel"
      style="margin-top:-50px;"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img class="item" src="/img/intro-carousel/home-1.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/16.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/comm-1.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/comm-4.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/3.jpg" alt="" />
      <img class="item" src="/img/intro-carousel/home-5.jpg" alt="" />
    </carousel>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  },
  data() {
    return {
      boolLoaded: false
    };
  }
};
</script>

<style lang="scss" scoped></style>
